exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.reading-hint[data-v-64207092] {\n  font-family: Avenir;\n  font-size: 13.5px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.18;\n  letter-spacing: 0.4px;\n  color: rgba(0, 0, 0, 0.6);\n}\n", ""]);

